---
title: "Latah Aux Comm / Latah ARES Weekly Net Script"
---

## Latah Aux Comm / Latah ARES Weekly Net Script

**Tuesdays at 1830**

**WA7HWD 146.820 Repeater**

------

**Net Control Opening Script**

"Good evening and welcome to the Latah Aux Comm / Latah ARES net. This is [Your Name], call sign [Your Call Sign], your net control operator for tonight.

This net meets weekly at 1830 on the WA7HWD 146.820 repeater, courtesy of the NW Tri-State Amateur Repeater Organization. We greatly appreciate their support, which enables us to conduct these nets. Please take a moment to thank them when you have the opportunity.

The purpose of this net is to:

1. Develop and maintain communication skills among participants.
2. Test the reliability and readiness of our communication systems.
3. Share updates and information related to emergency communications in Latah County and the surrounding area.
4. Foster community among amateur radio operators in our region.

All licensed amateur radio operators are welcome to check in, whether or not you are affiliated with Latah Aux Comm or ARES."

------

**Check-In Procedure**

"This is a directed net. Please follow net control's instructions and direct all communications through net control. To check in, please provide your call sign, name, and location.

We will begin with any stations with emergency or priority traffic. [Pause for response]

Hearing none, we will now take check-ins as follows:

1. **Latah Aux Comm and ARES members** — please check in now. [Pause for check-ins]
2. **Stations in Latah County, Idaho** — we will take check-ins by town. Please respond when your town is called:
   [Pause for each town's check-ins]
   - **Moscow**
   - **Genesee**
   - **Troy**
   - **Deary**
   - **Juliaetta/Kendrick**
   - **Potlatch**
   - **Bovill**
   - **Other Latah County towns**

1. **Stations outside Latah County or visitors** — please check in now. [Pause for check-ins]

------

**Net Activities**

"Tonight's net will include:

1. (optional) A brief discussion on [specific topic related to emergency communications].
2. Updates from Latah Aux Comm and ARES leadership, if available.
3. An opportunity for participants to share any announcements, technical questions, or practice traffic handling."

------

**Closing the Net**

"Thank you to everyone who checked in and participated tonight. A special thanks to the NW Tri-State Amateur Repeater Organization for allowing us to use the WA7HWD 146.820 repeater.

This concludes the Latah Aux Comm / Latah ARES net. The repeater is now returned to regular amateur use. This is [Your Call Sign], net control, signing off. 73."